// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form__container {
  background-color: var(--web-primary-color);
}
.contact-form__container h1 {
  color: var(--accent-color);
}

.contact-form__container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-form__info-text {
  color: var(--secondary-text-color);
}

.contact-form__content {
  display: grid;
  max-width: 100%;
  backface-visibility: hidden;
}
.contact-form__content div:last-child {
  display: flex;
  justify-content: flex-start;
}

@media only screen and (min-device-width: 320px) {
  .contact-form__container h1 {
    margin-bottom: 12px;
  }
  .contact-form__info-text {
    margin-bottom: 26px;
  }
  .contact-form__content {
    max-width: 100%;
    gap: 24px;
    grid-template-columns: 100%;
    grid-template-rows: repeat(4, 62px) 197px 41px;
  }
  .contact-form__content div:nth-child(5) {
    margin-bottom: 12px;
  }
  .contact-form__container-header button svg {
    width: 20px;
    height: 20px;
  }
}
@media only screen and (min-device-width: 768px) {
  .contact-form__container h1 {
    margin-bottom: 20px;
  }
  .contact-form__info-text {
    margin-bottom: 44px;
  }
  .contact-form__content {
    max-width: 480px;
    gap: 28px;
    grid-template-columns: 480px;
    grid-template-rows: repeat(4, 80px) 197px 46px;
  }
  .contact-form__content div:nth-child(5) {
    margin-bottom: 16px;
  }
  .contact-form__container-header button svg {
    width: 32px;
    height: 32px;
  }
}
@media only screen and (min-device-width: 992px) {
  .contact-form__container h1 {
    margin-bottom: 20px;
  }
  .contact-form__info-text {
    margin-bottom: 56px;
  }
  .contact-form__content {
    max-width: 940px;
    column-gap: 36px;
    row-gap: 20px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 84px 84px 140px 51px;
  }
  .contact-form__content div:nth-child(5) {
    grid-column-start: span 2;
    margin-bottom: 48px;
  }
  .contact-form__container-header button svg {
    width: 36px;
    height: 36px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .contact-form__container h1 {
    margin-bottom: 24px;
  }
  .contact-form__info-text {
    margin-bottom: 56px;
  }
  .contact-form__content {
    max-width: 1156px;
    column-gap: 36px;
    row-gap: 32px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 94px 94px 197px 64px;
  }
  .contact-form__content div:nth-child(5) {
    margin-bottom: 32px;
    grid-column-start: span 2;
  }
  .contact-form__container-header button svg {
    width: 36px;
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactForm/contactForm.scss"],"names":[],"mappings":"AAAA;EACE,0CAAA;AACF;AAAE;EACE,0BAAA;AAEJ;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AAAA;EACE,kCAAA;AAGF;;AAAA;EACE,aAAA;EACA,eAAA;EAEA,2BAAA;AAGF;AADE;EACE,aAAA;EACA,2BAAA;AAGJ;;AAGA;EAEE;IACE,mBAAA;EADF;EAGA;IACE,mBAAA;EADF;EAGA;IACE,eAAA;IACA,SAAA;IACA,2BAAA;IACA,8CAAA;EADF;EAEE;IACE,mBAAA;EAAJ;EAGC;IACC,WAAA;IACA,YAAA;EADF;AACF;AAGA;EAEE;IACE,mBAAA;EAFF;EAIA;IACE,mBAAA;EAFF;EAIA;IACE,gBAAA;IACA,SAAA;IACA,4BAAA;IACA,8CAAA;EAFF;EAGE;IACE,mBAAA;EADJ;EAIC;IACC,WAAA;IACA,YAAA;EAFF;AACF;AAIA;EACE;IACE,mBAAA;EAFF;EAIA;IACE,mBAAA;EAFF;EAIA;IACE,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,wCAAA;EAFF;EAGE;IACE,yBAAA;IACA,mBAAA;EADJ;EAIC;IACC,WAAA;IACA,YAAA;EAFF;AACF;AAIA;EACE;IACE,mBAAA;EAFF;EAIA;IACE,mBAAA;EAFF;EAIA;IACE,iBAAA;IACA,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,wCAAA;EAFF;EAGE;IACE,mBAAA;IACA,yBAAA;EADJ;EAIA;IACE,WAAA;IACA,YAAA;EAFF;AACF","sourcesContent":[".contact-form__container{\n  background-color: var(--web-primary-color);\n  h1 {\n    color: var(--accent-color);\n  }\n}\n.contact-form__container-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.contact-form__info-text{\n  color: var(--secondary-text-color);\n}\n\n.contact-form__content{\n  display: grid;\n  max-width: 100%;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n\n  div:last-child{\n    display: flex;\n    justify-content: flex-start;\n  }\n  //&:nth-child(4){\n  //  grid-column-start: span 2;\n  //}\n}\n@media only screen and (min-device-width: 320px) {\n\n  .contact-form__container h1{\n    margin-bottom: 12px;\n  }\n  .contact-form__info-text{\n    margin-bottom: 26px;\n  }\n  .contact-form__content{\n    max-width: 100%;\n    gap: 24px;\n    grid-template-columns: 100%;\n    grid-template-rows: repeat(4, 62px) 197px 41px;\n    div:nth-child(5){\n      margin-bottom: 12px;\n    }\n  }\n   .contact-form__container-header button svg{\n    width: 20px;\n    height: 20px;\n  }\n}\n@media only screen and (min-device-width: 768px) {\n\n  .contact-form__container h1{\n    margin-bottom: 20px;\n  }\n  .contact-form__info-text{\n    margin-bottom: 44px;\n  }\n  .contact-form__content{\n    max-width: 480px;\n    gap: 28px;\n    grid-template-columns: 480px;\n    grid-template-rows: repeat(4, 80px) 197px 46px;\n    div:nth-child(5){\n      margin-bottom: 16px;\n    }\n  }\n   .contact-form__container-header button svg{\n    width: 32px;\n    height: 32px;\n  }\n}\n@media only screen and (min-device-width: 992px) {\n  .contact-form__container h1{\n    margin-bottom: 20px;\n  }\n  .contact-form__info-text{\n    margin-bottom: 56px;\n  }\n  .contact-form__content{\n    max-width: 940px;\n    column-gap: 36px;\n    row-gap: 20px;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 84px 84px 140px 51px;\n    div:nth-child(5){\n      grid-column-start: span 2;\n      margin-bottom: calc(16px + 32px);\n    }\n  }\n   .contact-form__container-header button svg{\n    width: 36px;\n    height: 36px;\n  }\n}\n@media only screen and (min-device-width: 1366px) {\n  .contact-form__container h1{\n    margin-bottom: 24px;\n  }\n  .contact-form__info-text{\n    margin-bottom: 56px;\n  }\n  .contact-form__content{\n    max-width: 1156px;\n    column-gap: 36px;\n    row-gap: 32px;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 94px 94px 197px 64px;\n    div:nth-child(5){\n      margin-bottom: 32px;\n      grid-column-start: span 2;\n    }\n  }\n  .contact-form__container-header button svg{\n    width: 36px;\n    height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
